export default __webpack_public_path__ + "static/media/twitter.29b2c8f2.png";